import React from 'react';
import PropTypes from 'prop-types';
import { colourMasterLighter } from 'Styles/colors.css';
import { mouseScroll } from 'Shared/assets/images/';
import { LoadingSpinner } from 'PreviewComponents/ResizableContainer/LoadingSpinner';

export const RevealContainer = ({ artboardName, isDevice, width, height, children }) => {
  const revealFormat = true;
  return (
    <div style={{ width, height }}>
      <LoadingSpinner isDevice={isDevice} revealFormat={revealFormat} width={width} height={height} />
      <div
        style={{
          position: 'relative',
          width,
          left: '0',
          top: '0',
          backgroundColor: colourMasterLighter,
        }}
      >
        <div
          style={{
            position: 'absolute',
            width,
            height,
            margin: 0,
            padding: 0,
            clip: 'rect(0px, auto, auto, 0px)',
          }}
        >
          <div
            style={{
              position: 'fixed',
              width,
              height: '100%',
              left: 'auto',
              right: 'auto',
              transform: 'translateZ(0px)',
            }}
          >
            <div
              {...(!isDevice && { 'data-artboard': artboardName })}
              style={{
                position: 'absolute',
                width,
                height: '100%',
                left: '0',
                right: '0',
              }}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

RevealContainer.propTypes = {
  artboardName: PropTypes.string,
  children: PropTypes.element.isRequired,
  width: PropTypes.string.isRequired, // eslint-disable-line
  height: PropTypes.string.isRequired, // eslint-disable-line
  isDevice: PropTypes.bool,
};

RevealContainer.defaultProps = {
  isDevice: false,
  artboardName: '',
};

export const Revealhelper = ({ isDevice }) => {
  const leftMargin = isDevice ? '0px' : '-20px';
  const width = '100%';
  return (<div
    style={{
      position: 'absolute',
      margin: 'auto',
      top: 'calc(100vh - 50vh)',
      width,
      textAlign: 'center',
      marginLeft: leftMargin,
    }}
  >
    <span
      style={{
        textTransform: 'uppercase',
        fontFamily: 'Montserrat',
        fontSize: '11px',
      }}
    >
      Scroll down to preview
    </span>
    <img
      src={mouseScroll}
      alt={'scroll down'}
      style={{
        width: '100px',
        height: '100px',
        display: 'block',
        margin: 'auto',
      }}
    />
  </div>
  );
};

Revealhelper.propTypes = {
  isDevice: PropTypes.bool.isRequired,
};

Revealhelper.defaultProps = {
  isDevice: false,
};



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/ResizableContainer/RevealContainer.jsx